"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramStatus = void 0;
var ProgramStatus;
(function (ProgramStatus) {
    ProgramStatus["Active"] = "Active";
    ProgramStatus["Draft"] = "Draft";
    ProgramStatus["Deactivated"] = "Deactivated";
})(ProgramStatus || (exports.ProgramStatus = ProgramStatus = {}));
//# sourceMappingURL=types.js.map